import { signal } from 'services/SignalsService'
import { StoreageService } from 'services/StoreageService'

export default class BonusMultiplierModel {
  constructor() {
    this.winModel = null
    this.range = [1, 3, 5, 7, 9]
    this.count = null
    this.isFS = null
    this.data = {
      multiplier: 1,
      skip: false,
    }

    this.createSignal()
  }

  createSignal() {
    signal.on('ACTION:REEL-SPIN', this.counter.bind(this))
    signal.on('FREESPINS-MODE', this.FS.bind(this))
    signal.on('STATE:IN:FS-START', this.clear.bind(this))
    signal.on('STATE:IN:FS-END', this.clear.bind(this))
  }

  counter() {
    this.winModel = game.models.WinModel.get()
    this.freeSpinModel  = game.models.FreespinModel.get()
    const action = game.models.SpinModel.get().action
    if(action === 'fsProgressiveMultiplier') {
      this.data.multiplier  =  this.freeSpinModel.multiplier
      this.data.skip = false
    }
    else {
      if (this.isFS && this.winModel.winLines.length && this.count < this.range.length - 1) {
        this.count ++
        StoreageService.set('bonusMultiplier', this.count)
        this.data.multiplier = this.range[this.count]
        this.data.skip = false
      }
      else if ((this.isFS && !this.winModel.winLines.length) || (this.count == this.range.length - 1)) {
        this.data.skip = true
      }
    }

  }

  FS(value) {
    this.isFS = value
  }

  clear() {
    this.count = 0
    this.data.multiplier = this.range[this.count]
    this.data.skip = false
    StoreageService.set('bonusMultiplier', this.count)
  }

  get() {
    return this.data
  }

  set(value) {
    this.count = value
    this.data.multiplier = this.range[this.count]
  }
}
